<nav class="preview-header">
  <div class="back">
    <ng-content select="[backBtn]"></ng-content>
  </div>
  <div class="title">
    <ng-content select="[previewTitle]"></ng-content>
  </div>
  <div class="close">
    <ng-content select="[closeBtn]"></ng-content>
  </div>
</nav>
